import cube from '@cubejs-client/core';
import { cubeApiUrl } from '../../constants/cube.constants';
const studioEnv = process.env.STUDIO_ENV;
export const getCubeApi = ({ entityId, studyId, activeReportsTab, selectedTestEnv, prodOrgs, disablePreAggs, env = 'test', }) => {
    let _cubeApiUrl = cubeApiUrl;
    if (studioEnv === 'production') {
        if (env === 'test' || activeReportsTab === 0) {
            _cubeApiUrl = 'https://analytics-eu1-dev.medable.com/cubejs-api/v1';
        }
        else if (env === 'prod' || activeReportsTab === 1) {
            _cubeApiUrl = 'https://analytics-eu1.medable.com/cubejs-api/v1';
        }
    }
    const headers = {
        'X-Entity-Id': entityId || '',
        'X-Study-Id': studyId || '',
        'X-Env': env || (activeReportsTab === 0 ? 'test' : 'prod'),
    };
    if ((activeReportsTab === 0 || env === 'test') && selectedTestEnv.value) {
        headers['X-Orgs'] = JSON.stringify([selectedTestEnv.value]);
    }
    if ((activeReportsTab === 1 || env === 'prod') && prodOrgs.length > 0) {
        headers['X-Orgs'] = JSON.stringify(prodOrgs);
    }
    // Add X-Preaggs header based on disablePreAggs flag
    if (disablePreAggs === true) {
        headers['X-Preaggs'] = 'false';
    }
    return cube('', {
        apiUrl: _cubeApiUrl,
        headers,
        credentials: 'include',
    });
};
